/**
 * 新的tree组件
 * props:elementUI的tree的所有props；
 * headerShowflag：设置是否显示添加、删除、修改按钮，
 * checkboxmode设置显示num
 * 事件：绑定elementUI的truee组件事件前面加个tree如@treenode-click；node-add添加事件；node-edit编辑事件；node-del删除事件
 */
import {Tree} from 'element-ui'
import '../../style/tree/index.less'
import TreeRender from './tree_render'
const thisProps = {
  checkboxmode: {
    type: Boolean,
    default: false
  },
  headerShowflag: {
    type: Boolean,
    default: false
  },
  treeRef: {
    type: String
  },
  singleCheck: {
    type: Boolean,
    default: false
  },
  ...Tree.props
}
export default {
  name: 'treeNew',
  props: thisProps,
  data () {
    return {
      maxExpandNum: 15
    }
  },
  methods: {
    handleAdd (s, d, n) {
      this.$emit('node-add', s, d, n)
    },
    nodeEditPass (s, d, n) {
      this.$emit('node-edit', s, d, n)
    },
    handleDel (s, d, n) {
      this.$emit('node-del', s, d, n)
    },
    filter (val) {
      this.$refs.treeEl.filter(val)
    },
    unCheckedItem (val) {
      this.$refs.treeEl.setChecked(val, false, true)
    },
    checkedItem (val) {
      this.$nextTick(() => {
        val.forEach(item => {
          this.$refs.treeEl.setChecked(item.id, true, true)
        })
      })
    },
    setCheckedKeys (keys, leafOnly) {
      this.$refs.treeEl.setCheckedKeys(keys, leafOnly)
    },
    setCurrentKey (key) {
      this.$refs.treeEl.setCurrentKey(key)
    },
    InitTreeSelectedSta (obj, excludeId) {
      if (obj === undefined) {
        return
      }

      for (let i of obj) {
        if (i.id !== excludeId) {
          this.$refs.treeEl.setChecked(i, false, false) // 全部取消选中状态
        }
        if (Array.isArray(i.nodes) && i.nodes.length > 0) this.InitTreeSelectedSta(i.nodes, excludeId)
      }
    },
    getNode (val) {
      return this.$refs.treeEl.getNode(val)
    },
    getCheckedNodes () {
      return this.$refs.treeEl.getCheckedNodes()
    },
    getCheckedKeys () {
      return this.$refs.treeEl.getCheckedKeys()
    }
  },
  mounted () {
    var that = this
    window.setTimeout(o => {
      var domlist = that.$refs.treeEl && that.$refs.treeEl.$el.querySelectorAll('span.el-tree-node__expand-icon')
      if (domlist && domlist.length === 1) {
        domlist[0].click()
      }
    }, 800)
  },
  render (h) {
    const props = { ...this.$props }
    const that = this
    let treeListeners = Object.keys(this.$listeners).reduce((obj, key) => {
      if (key.indexOf('tree') > -1) {
        let newkey = key.replace('tree', '')
        obj[newkey] = this.$listeners[key]
      }
      return obj
    }, {})
    if (this.$props.singleCheck) {
      let fn = ''
      let checkChange = 'check-change'
      if (typeof treeListeners[checkChange] === 'function') fn = treeListeners[checkChange]
      treeListeners[checkChange] = function (curNode, isSelfSelected) {
        if (isSelfSelected === true) {
          that.InitTreeSelectedSta(that.$refs.treeEl.getCheckedNodes(), curNode.id)
        }
        fn && fn(curNode, isSelfSelected)
      }
    }
    props['renderContent'] = function (h, {
      node,
      data,
      store
    }) {
      return h(TreeRender, {
        props: {
          DATA: data,
          NODE: node,
          props: props.props,
          STORE: store,
          clicknode: that.clicknode,
          maxexpandId: that.non_maxexpandId,
          // filterVal: this.filterVal,
          checkboxmode: that.checkboxmode,
          headerShowflag: that.headerShowflag
        },
        on: {
          nodeAdd: (s, d, n) => that.handleAdd(s, d, n),
          nodeDel: (s, d, n) => that.handleDel(s, d, n),
          nodeEditPass: (s, d, n) => that.nodeEditPass(s, d, n)
        }
      })
    }
    props['filterNodeMethod'] = function (value, data, node) {
      if (!value) {
        return true
      }
      if (data[this.$props.props.label].indexOf(value) !== -1) {
        if (this.$refs.treeEl.lazy) {
          let _node = node
          while (_node.parent) {
            _node.parent.expanded = true
            _node = _node.parent
          }
        }
        return true
      } else {
        return false
      }
    }.bind(this)
    let render = []
    if (this.$slots.default) {
      render.push(h('div', {}, this.$slots.default))
    }
    props['nodeKey'] = props['nodeKey'] || 'id'
    return h('div', {
      id: 'treeExpand',
      class: ['expand', {
        'expand-padding': !!this.$slots.default
      }]
    }, [
      ...render,
      h('div', {
        class: 'tree_dem'
      }, [
        h('el-tree', {
          on: treeListeners,
          props: props,
          class: 'expand-tree',
          ref: 'treeEl'
        })
      ])
    ])
  }
}



// WEBPACK FOOTER //
// ./src/components/tree/treeNew.js